import './product_extra.css';
import { useSingleProduct } from "../../context/SingleProductContext";

export const ProductExtra = ({option}) => {
    //HOOKS
    const { options, setSelectedExtra, optionsErrors } = useSingleProduct();

    //EVENT HANDLERS
    const handleChoiceChange = (e) => {
        setSelectedExtra(option.id, e.target.value);
    }

    return (
        <div className='product_options_extra_container'>
            <h2>
                {option.name}
            </h2>
            <div className='product_options_container'>
                {
                    option.max > 0 && (
                        <p>
                            Select up to { option.max } options
                        </p>
                    )
                }
                <span className='error_msg'>
                    { optionsErrors && optionsErrors[option.id] && optionsErrors[option.id] }
                </span>
                <div className='checkbox_container'>
                    {
                        options && options[option.id] && option.choices.map(choice => {
                            return (
                                <div className='option_container' key={'option_' + option.id + '_choice_' + choice.id}>
                                    <input 
                                        type="checkbox"
                                        id={'option_' + option.id + '_choice_' + choice.id}
                                        value={choice.id}
                                        checked={options[option.id].choices.includes(choice.id)}
                                        onChange={handleChoiceChange}
                                    />
                                    <label
                                        htmlFor={'option_' + option.id + '_choice_' + choice.id}
                                    >
                                        {choice.name} +${choice.price / 100}
                                    </label>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}